import type { DungeonRoom, GameMode } from './types';

/** Derive UI/game mode from the room the player is standing in (not combat/dead). */
export function modeFromRoom(room: DungeonRoom | undefined): GameMode {
  if (!room) {
    return { type: 'exploration' };
  }

  if (!room.isCleared) {
    switch (room.type) {
      case 'NORMAL_ENEMY':
      case 'ELITE_ENEMY':
      case 'BOSS':
        return { type: 'monster', roomId: room.id };
      case 'NPC':
        return { type: 'npc', roomId: room.id };
      case 'TREASURE':
      case 'TRAP':
      case 'SECRET':
      case 'TELEPORTER':
        return { type: 'event', roomId: room.id };
      default:
        break;
    }
  }

  if (room.type === 'NPC') {
    return { type: 'npc', roomId: room.id };
  }

  return { type: 'exploration' };
}
